import React, { useContext } from "react";

import { useApolloClient } from "@apollo/client";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";
import Modal from "shared/components/Modal";
import { NAME_SPACES } from "shared/locals/constants";
import { StoreContext } from "shared/store";
import { PATHS } from "utils/constants";
import "./styles.scss";

const Contact = (props) => {
  const history = useHistory();
  const client = useApolloClient();
  const { t } = useTranslation(NAME_SPACES.HOME);
  const { clearStore } = useContext(StoreContext);

  const onLogout = async () => {
    await client.cache.reset();
    clearStore();
  };

  const navigateToProfile = () => {
    history.push(PATHS.ACCOUNT);
  };
  return (
    <Modal {...props}>
      <div className="contact-modal-element" onClick={navigateToProfile}>
        <u>{t("ACCOUNT")}</u>
      </div>
      <div className="contact-modal-element" onClick={onLogout}>
        <u>{t("LOGOUT")}</u>
      </div>
    </Modal>
  );
};

export default Contact;
